import script from "./ArtCraftList.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtCraftList.vue?vue&type=script&setup=true&lang=js"

import "./ArtCraftList.vue?vue&type=style&index=0&id=72e58851&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e58851"]])

export default __exports__